import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/pro-regular-svg-icons";
import { Anchor } from "../Anchor";
import { RWA_URLS } from "~/consts";
import { NavigationUserEvents } from "~/modules/analytics/events/navigation";

// // // //

const issuerNetworkCtaLabel = "Register Your Assets";

const issuerNetworkAnimatedBadgeClassName =
    "relative flex h-5 min-w-[3.25rem] shrink-0 items-center justify-center overflow-hidden rounded border border-amber-300/80 bg-white/70 px-1 text-[0.625rem] text-amber-700";

const issuerNetworkCtaClassName =
    "group flex w-full items-center justify-between gap-1.5 rounded border border-amber-200 bg-amber-100 px-2.5 py-1 text-xs whitespace-nowrap text-left text-amber-700 select-none transition-all hover:bg-amber-200/60 hover:shadow-xs";

function AnimatedCtaBadge() {
    return (
        <span
            aria-hidden="true"
            className={issuerNetworkAnimatedBadgeClassName}
        >
            <span className="absolute inset-0 flex items-center justify-center transition-all duration-200 ease-out group-hover:-translate-y-full group-hover:opacity-0 motion-reduce:transform-none motion-reduce:transition-none">
                START
            </span>
            <span className="absolute inset-0 flex translate-y-full items-center justify-center text-xs opacity-0 transition-all duration-200 ease-out group-hover:translate-y-0 group-hover:opacity-100 motion-reduce:transform-none motion-reduce:transition-none">
                {"\u2197"}
            </span>
        </span>
    );
}

export function RegisterAssetCTA() {
    return (
        <div className="border-t border-slate-500/10 bg-sidebar px-4 pb-6 pt-4">
            <div className="mb-2 text-xs font-normal text-muted-foreground">
                For Issuers & Tokenization Platforms
            </div>
            <Anchor
                openInNewTab
                href={RWA_URLS.directorySignUp}
                analyticsLabel={
                    NavigationUserEvents.sidebarRegisterAssetCtaClick
                }
                className={issuerNetworkCtaClassName}
            >
                <span className="flex min-w-0 items-center gap-2">
                    <FontAwesomeIcon
                        className="h-3.5 w-3.5 shrink-0"
                        icon={faGlobe}
                    />
                    <span className="leading-tight whitespace-nowrap">
                        {issuerNetworkCtaLabel}
                    </span>
                </span>
                <AnimatedCtaBadge />
            </Anchor>
        </div>
    );
}
